import script from "./UserDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserDetail.vue?vue&type=script&setup=true&lang=ts"

import "./UserDetail.vue?vue&type=style&index=0&id=0b1a52e2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b1a52e2"]])

export default __exports__